module.exports = __webpack_public_path__ + "static/media/logo.b3d51882.svg";